/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import LocaleContext from 'constants/localization';

const SaveButton = ({ onSubmit, disabled, label, accessKey }) => {
  const [saving, setSaving] = useState(false);
  const LS = useContext(LocaleContext);

  label = label || LS.actions.save;

  const onSave = e => {
    setSaving(true);
    const promise = onSubmit(e);

    if (promise && Promise.resolve(promise) == promise) {
      promise.finally(() => setSaving(false));
    } else {
      setSaving(false);
    }
  };

  return <button
    accessKey={accessKey}
    type="button" 
    className="action-button"
    disabled={disabled || saving}
    onClick={onSave} >{label}</button>;
};

export default SaveButton;